function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This component is deprecated. Please use Collapse instead.
//

/* eslint-disable no-use-before-define, quote-props, jsx-a11y/no-static-element-interactions */
import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, color, spacing, transition } from "../../styles/theme";
import { SvgChevronUp, SvgChevronDown } from "../../svg";
import Measure from 'react-measure';
var CONFIG = {
  duration: 0.3
}; // TODO(Audrey): customize duration when needed

/**
 * A highly customizable Expandable container that accepts header node and children
 * Useful for creating simple expandable/collapsible components or accordions
 * If you know the content height, pass the fixedContentHeight to increase performance
 * Otherwise we'll measure the children's content height and use it to animate
 */

var Expandable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Expandable, _React$Component);

  function Expandable(props, context) {
    var _this;

    _classCallCheck(this, Expandable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Expandable).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "state", void 0);

    _defineProperty(_assertThisInitialized(_this), "onToggle", function () {
      var isOpened = !_this.state.isOpened;

      _this.setState({
        isOpened: isOpened
      });

      if (_this.props.onToggle) {
        _this.props.onToggle(_this.props.id, isOpened);
      }
    });

    _this.state = {
      isOpened: !!props.isOpened,
      contentContainerHeight: -1
    };
    return _this;
  }

  _createClass(Expandable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('isOpened' in nextProps && nextProps.isOpened !== this.props.isOpened) {
        this.setState({
          isOpened: nextProps.isOpened
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          defaultContentHeight = _this$props.defaultContentHeight,
          fixedContentHeight = _this$props.fixedContentHeight,
          footer = _this$props.footer,
          header = _this$props.header,
          hideArrow = _this$props.hideArrow,
          hideBorder = _this$props.hideBorder,
          hideBorderBottom = _this$props.hideBorderBottom,
          hideHeader = _this$props.hideHeader,
          htmlAttributes = _this$props.htmlAttributes,
          isFullBleed = _this$props.isFullBleed,
          isThemeDark = _this$props.isThemeDark,
          rootClassName = _this$props.rootClassName,
          style = _this$props.style,
          isArrowOnLeft = _this$props.isArrowOnLeft,
          bodyRole = _this$props.bodyRole;
      var _this$state = this.state,
          isOpened = _this$state.isOpened,
          contentContainerHeight = _this$state.contentContainerHeight;
      return React.createElement("div", _extends({}, htmlAttributes, css(rootClassName, styles.Expandable, styles["content".concat(isThemeDark ? 'ThemeDark' : '')], !hideBorder && styles["borderAll".concat(isThemeDark ? 'ThemeDark' : '')], hideBorderBottom && styles.hideBorderBottom, isFullBleed && styles.fullBleedContainer), {
        style: style,
        role: bodyRole
      }), !hideHeader && React.createElement("div", _extends({}, css('horizontal-box align-items-vertical-center', styles.header), {
        onClick: this.onToggle,
        "aria-expanded": isOpened
      }), !hideArrow && isArrowOnLeft && React.createElement("div", css(styles.arrowContainer), isOpened && React.createElement(SvgChevronUp, {
        isThemeDark: isThemeDark
      }), !isOpened && React.createElement(SvgChevronDown, {
        isThemeDark: isThemeDark
      })), React.createElement("div", {
        className: "horizontal-box flex-1 p-x-1s"
      }, header), !hideArrow && !isArrowOnLeft && React.createElement("div", css(styles.arrowContainer), isOpened && React.createElement(SvgChevronUp, {
        isThemeDark: isThemeDark
      }), !isOpened && React.createElement(SvgChevronDown, {
        isThemeDark: isThemeDark
      }))), fixedContentHeight && React.createElement("div", _extends({}, css(styles.transitionContainer), {
        style: {
          height: isOpened ? fixedContentHeight : defaultContentHeight
        }
      }), children), !fixedContentHeight && React.createElement("div", _extends({}, css(styles.transitionContainer), {
        style: {
          height: isOpened ? contentContainerHeight : defaultContentHeight
        }
      }), React.createElement(Measure, {
        bounds: true,
        onResize: function onResize(_ref) {
          var height = _ref.bounds.height;
          return _this2.setState({
            contentContainerHeight: height
          });
        }
      }, function (_ref2) {
        var measureRef = _ref2.measureRef;
        return React.createElement("div", {
          ref: measureRef
        }, children);
      })), footer && React.createElement("div", _extends({}, css('horizontal-box align-items-vertical-center', styles.footer), {
        onClick: this.onToggle
      }), React.createElement("div", {
        className: "horizontal-box flex-1"
      }, footer), !hideArrow && React.createElement("div", css(styles.footerArrowContainer), isOpened && React.createElement(SvgChevronUp, {
        isThemeDark: isThemeDark
      }), !isOpened && React.createElement(SvgChevronDown, {
        isThemeDark: isThemeDark
      }))));
    }
  }]);

  return Expandable;
}(React.Component);

_defineProperty(Expandable, "propTypes", {
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  // Override the inline-styles of the root element.
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  isThemeDark: PropTypes.bool,
  // A way to differentiate each expandable, will be passed back when onToggle is triggered
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // Click event
  onToggle: PropTypes.func,
  header: PropTypes.node,
  footer: PropTypes.node,
  isOpened: PropTypes.bool,
  hideArrow: PropTypes.bool,
  hideBorder: PropTypes.bool,
  // If provided, we'll not dinamically calculate main content container height
  fixedContentHeight: PropTypes.number,
  // Userful to show a preview of the content
  defaultContentHeight: PropTypes.number,
  // userful for rending accordions
  hideBorderBottom: PropTypes.bool,
  hideHeader: PropTypes.bool,
  children: PropTypes.node,
  // Whether to put padding on header and content body
  isFullBleed: PropTypes.bool,
  isArrowOnLeft: PropTypes.bool,
  bodyRole: PropTypes.string
});

_defineProperty(Expandable, "defaultProps", {
  htmlAttributes: {},
  style: {},
  defaultContentHeight: 0,
  bodyRole: 'region'
});

export default Expandable;
var styles = StyleSheet.create({
  Expandable: {
    position: 'relative',
    width: '100%',
    transition: transition.easeOut(),
    userSelect: 'none',
    padding: '8px 16px'
  },
  fullBleedContainer: {
    padding: 0
  },
  content: {
    color: color.primaryText
  },
  contentThemeDark: {
    color: color.primaryTextThemeDark
  },
  borderAll: {
    border: "1px solid ".concat(color.divider)
  },
  borderAllThemeDark: {
    border: "1px solid ".concat(color.dividerThemeDark)
  },
  hideBorderBottom: {
    borderBottom: 'none'
  },
  borderBottomThemeDark: {
    borderBottom: "1px solid ".concat(color.dividerThemeDark)
  },
  header: {
    cursor: 'pointer',
    minHeight: 24,
    width: '100%',
    lineHeight: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  arrowContainer: {},
  footer: {
    cursor: 'pointer',
    minHeight: 24,
    marginTop: spacing.sm,
    width: '100%',
    lineHeight: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  footerArrowContainer: {},
  transitionContainer: {
    overflow: 'hidden',
    transition: "height ".concat(CONFIG.duration, "s ").concat(transition.easeOutFunction)
  }
});